export default "__VITE_ASSET__BMZ1F3RZ__"